module.exports = __webpack_public_path__ + "media/profile/badge-4967aa62.png";